module.exports = __webpack_public_path__ + "img/translate-ten.8cf7dc62.png";